export const UPDATE_SGZ_MARKER_DATA = 'UPDATE_SGZ_MARKER_DATA'

export function sgzMarkerDataReducer (state = {}, action) {
    switch (action.type){
        case UPDATE_SGZ_MARKER_DATA:
            return action.payload
        default: return state
    }
}
